// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2vy7j","buttons":"SendReceipts_buttons__3W2bh","email":"SendReceipts_email__1u9OY","bookApptTitle":"SendReceipts_bookApptTitle__2gKwV"};